// directives/drag-scroll.js
export default {
  inserted(el) {
    let isDown = false;
    let startX = 0;
    let startPageX = 0;
    let scrollLeft = 0;
    let moved = 0;
    const THRESHOLD = 5; // px

    const onMouseDown = (e) => {
      isDown = true;
      moved = 0;
      startX = e.pageX - el.offsetLeft;
      startPageX = e.pageX;
      scrollLeft = el.scrollLeft;
      el.classList.add('is-dragging');
    };

    const onMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      el.scrollLeft = scrollLeft - (x - startX);
      moved = Math.abs(e.pageX - startPageX);
    };

    const onMouseUp = () => {
      isDown = false;
      el.classList.remove('is-dragging');
    };

    // Capture phase so we run before the link's own click handler
    const onClickCapture = (e) => {
      if (moved > THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
        moved = 0;
      }
    };

    // Prevent native image drag inside the scroller
    const onDragStart = (e) => e.preventDefault();

    el.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    el.addEventListener('click', onClickCapture, true); // capture: true
    el.addEventListener('dragstart', onDragStart);

    // eslint-disable-next-line
    el._dragScrollCleanup = () => {
      el.removeEventListener('mousedown', onMouseDown);
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      el.removeEventListener('click', onClickCapture, true);
      el.removeEventListener('dragstart', onDragStart);
    };
  },
  unbind(el) {
    // eslint-disable-next-line
    el._dragScrollCleanup && el._dragScrollCleanup();
    // eslint-disable-next-line
    delete el._dragScrollCleanup;
  },
};
